import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ConnectModule } from '@epicuro-next/addons/connect';
import { AlertModule } from '@epicuro-next/ataraxia/alert';
import { AsideMenuModule } from '@epicuro-next/ataraxia/aside-menu';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { ClickOutsideModule } from '@epicuro-next/ataraxia/click-outside';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { InputWithIconModule } from '@epicuro-next/ataraxia/input-with-icon';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { SITE_SELECTOR_NAMESPACE } from '@epicuro-next/constants/rule-engine/site-selector-rules';
import { FiltersListModule } from '@epicuro-next/features/filters-list';
import { ProductsFiltersModule } from '@epicuro-next/features/products-filters';
import { ProductsSearchListModule } from '@epicuro-next/features/products-search-list';
import { SecondaryNavigationBarModule } from '@epicuro-next/features/secondary-navigation-bar';
import { SiteSelectorModule } from '@epicuro-next/features/site-selector';
import { UserMenuModule } from '@epicuro-next/features/user-menu';
import {
  ConfigurationModule,
  NAMESPACE_CONNECT,
  NAMESPACE_NAVIGATION,
  NAMESPACE_PRODUCT_BASKET,
  NAMESPACE_SEARCH_SUGGEST,
} from '@epicuro-next/platform/configuration';
import { EnvironmentModule } from '@epicuro-next/platform/environment';
import { RecommendationPanelsModule } from '@epicuro-next/recommendation-panels';
import { ConnectStateModule } from '@epicuro-next/state/connect-state';
import { PBasketStateModule } from '@epicuro-next/state/p-basket-state';
import { ProductListStoreModule } from '@epicuro-next/state/product-list-state';
import { RouterStoreModule } from '@epicuro-next/state/router-store';
import { ScanStateModule } from '@epicuro-next/state/scan-state';
import { UserUiStateModule } from '@epicuro-next/state/user-ui-state';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { LetDirective } from '@ngrx/component';
import { AtaraxiaTypeWriterComponent } from 'ataraxia-type-writer';

import { BasketButtonComponent } from './basket-button/basket-button.component';
import { BasketNotificationComponent } from './basket-notification/basket-notification.component';
import { BrandIndicatorComponent } from './brand-indicator/brand-indicator.component';
import { FullHeaderComponent } from './full-header/full-header.component';
import { MainNavigationComponent } from './main-navigation/main-navigation.component';
import { NavLinkComponent } from './nav-link/nav-link.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SearchSuggestComponent } from './search-suggest/search-suggest.component';
import { NavigationService } from './service/navigation.service';
import { SplitNavigationComponent } from './split-navigation/split-navigation.component';

@NgModule({
  declarations: [
    MainNavigationComponent,
    SearchBarComponent,
    NavLinkComponent,
    BasketButtonComponent,
    FullHeaderComponent,
    SplitNavigationComponent,
    BrandIndicatorComponent,
    BasketNotificationComponent,
  ],
  imports: [
    AtaraxiaTypeWriterComponent,
    InputWithIconModule,
    ProductListStoreModule,
    ReactiveFormsModule,
    CommonModule,
    IconsModule,
    RouterModule,
    PopoverModule,
    AvatarModule,
    AsideMenuModule,
    NgbNavModule,
    UserMenuModule,
    PBasketStateModule,
    UserUiStateModule,
    ConnectStateModule,
    ConfigurationModule.forFeature([
      NAMESPACE_CONNECT,
      NAMESPACE_PRODUCT_BASKET,
      NAMESPACE_NAVIGATION,
      SITE_SELECTOR_NAMESPACE,
      NAMESPACE_SEARCH_SUGGEST,
    ]),
    SiteSelectorModule,
    ConnectModule,
    RouterStoreModule,
    ModalModule,
    FiltersListModule,
    ImageModule,
    ClickOutsideModule,
    ProductsFiltersModule,
    ProductListStoreModule,
    SecondaryNavigationBarModule,
    EnvironmentModule,
    ScanStateModule,
    RecommendationPanelsModule,
    AlertModule,
    ProductsSearchListModule,
    LetDirective,
    SearchSuggestComponent,
  ],
  exports: [MainNavigationComponent],
  providers: [NavigationService],
})
export class MainNavigationModule {}
